import { Box, Typography } from "@mui/material";
import CustomButton from "../../UIElements/CustomButton";
import { RoutesEnum } from "../../../router/routes";

export default function ConfirmationSuccessSignup() {
    return (
        <Box
            sx={{
                marginLeft: "1.5rem",
                marginTop: "7rem",
                marginRight: "1.5rem",
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                marginBottom: "1.5rem",
                justifyContent: "center",
                alignItems: "center",

                "@media (max-width:1024px)": {
                    marginTop: "4.37rem",
                },
            }}
        >
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        color: "#005499",
                        textAlign: "center",
                        fontFamily: "Roboto",
                        fontSize: "1.75rem",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "normal",
                    }}
                >
                    Votre compte a été créé avec succès !
                </Typography>
            </Box>
            <Box
                sx={{
                    width: "15.5rem",
                    height: "20.5rem",
                    flexShrink: 0,
                    "@media (max-width:1024px)": {
                        height: "15.5rem",
                    },
                }}
            ></Box>

            <CustomButton
                label="Terminer"
                withoutendcon
                onClick={() => {
                    window.location.replace("/" + RoutesEnum.login);
                }}
            />
        </Box>
    );
}
